import React, { useState } from "react";
import moment from "moment";
import { IP } from "../../../../internalServer";
import assets from "../../../../assets/assets";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  TextField,
  Tooltip,
} from "@mui/material";
import { Check, DeleteIcon, Edit2Icon, EditIcon } from "lucide-react";
import { Close, DeleteOutline, Edit } from "@mui/icons-material";
import { toast } from "react-toastify";
import axios from "../../../../axios";
// css comes in feed Details

const CommentList = ({
  setIsCommented,
  isCommented,
  commentData,
  comment_id,
  post_id,
  setComments,
  setIsInProgress,
  isInProgress,
  currentCommentNumber,
  setCurrentCommentNumber,
  filter,
  setFilter,
  members,
  communityId,
  post,
  getPostComme,
}) => {
  const { page } = filter;
  let user_id = JSON.parse(localStorage.getItem("Teacher_id"));
  const [selectedCommentId, setSelectedCommentId] = useState(null);
  const [editMode, setEditMode] = useState(false);
  const [editedComment, setEditedComment] = useState("");
  const [deletePopup, setDeletePopup] = useState(false);
  // console.log("comment_id", comment_id);

  const Teacher_id = JSON.parse(localStorage.getItem("Teacher_id"));
  const handleCommentClick = (commentId) => {
    // When a comment is clicked, toggle the selected comment ID
    setSelectedCommentId(commentId === selectedCommentId ? null : commentId);
  };
  const DeleteComment = async () => {
    setIsInProgress(!isInProgress);
    try {
      let res = await axios.delete(
        `/api/v1/community/post/${post_id}/comment/delete/${commentData?.id}?sortBy=-1`,
        {
          data: { user_id },
        }
      );

      res && setIsCommented(!isCommented);
      setFilter({ ...filter, page: 1 });
      setComments([]);
      // setIsInProgress(!isInProgress);
      getPostComme();
      setCurrentCommentNumber(currentCommentNumber - 1);
    } catch (error) {
      console.log(error);
    }
  };
  const isAdminOrTeacherAdmin = members.some((member) => {
    if (member.admins_id) {
      return member.admins_id.some((admin) => admin.admin.id === user_id);
    } else if (member.teachers_id) {
      return member.teachers_id.some(
        (teacher) =>
          teacher.teacher.id === user_id && teacher.role === "moderator"
      );
    }
    return false;
  });

  const timeHelper = (a) => {
    const dateObj = new Date(a);
    dateObj.setUTCHours(dateObj.getUTCHours() + 5);
    dateObj.setUTCMinutes(dateObj.getUTCMinutes() + 30);
    const day = dateObj.getUTCDate();
    const month = dateObj.getUTCMonth() + 1;
    const year = dateObj.getUTCFullYear();
    const hours = dateObj.getUTCHours();
    const minutes = dateObj.getUTCMinutes();
    const seconds = dateObj.getUTCSeconds();
    const outputDateString = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;

    return outputDateString;
  };
  function shortenParagraph(text, maxLength) {
    if (text?.length <= maxLength) {
      return text;
    }
    return text?.slice(0, maxLength)?.trim() + "...";
  }

  const handleSaveEdit = async () => {
    try {
      const res = await axios.put(
        `/api/v1/community/post/${post_id}/comment/update/${commentData?.id}`,
        {
          user_id: Teacher_id,
          comment: editedComment,
        }
      );
      console.log(res, "res of edited commetn");
      if (res.data.status) {
        setEditMode(false);
        getPostComme();
        toast.success(res.data.message);
      }
    } catch (err) {
      console.log(err);
      toast.error(err?.response?.data?.message);
    }
  };

  function isUpdatedAfterCreated(createdAt, updatedAt) {
    // Convert the date strings into Date objects
    const createdDate = new Date(createdAt);
    const updatedDate = new Date(updatedAt);

    // Compare the two dates
    return updatedDate > createdDate;
  }

  return commentData ? (
    <div className="mb-2 position-relative w-100">
      <div className="d-flex gap-2 align-items-center w-100">
        {commentData?.user_id?.user_type === "Teacher" ? (
          <img
            src={
              commentData?.user_id?.profile_picture
                ? IP + commentData?.user_id?.profile_picture.replace(/^\./, "")
                : commentData?.user_id?.gender === "M"
                ? "/images/Teacher_Male.jpg"
                : commentData?.user_id?.gender === "F"
                ? "/images/Teacher_Female.png"
                : "/images/default-profile.png"
            }
            alt="icon"
            className="profilePicImg"
            style={{ width: "25px", height: "25px", borderRadius: "50%" }}
            onError={(e) => {
              // This function will run if the image fails to load
              if (commentData?.user_id?.gender === "M") {
                e.target.src = "/images/Teacher_Male.jpg";
              } else if (commentData?.user_id?.gender === "F") {
                e.target.src = "/images/Teacher_Female.png";
              } else {
                e.target.src = "/images/default-profile.png";
              }
            }}
          />
        ) : (
          <img
            src={
              commentData?.user_id?.profile_picture
                ? IP + commentData?.user_id?.profile_picture.replace(/^\./, "")
                : commentData?.user_id?.gender === "M"
                ? commentData?.user_id?.avatar_profile
                  ? "/images/Boys/" +
                    commentData?.user_id?.avatar_profile +
                    ".webp"
                  : "/images/Student_boy_pic.png"
                : commentData?.user_id?.gender === "F"
                ? commentData?.user_id?.avatar_profile
                  ? "/images/Girls/" +
                    commentData?.user_id?.avatar_profile +
                    ".webp"
                  : "/images/Student_girl_pic.png"
                : "/images/default image.png"
            }
            alt="icon"
            className="prifilePicImg"
            key={commentData?.user_id?.avatar_profile}
            style={{ width: "25px", height: "25px", borderRadius: "50%" }}
            onError={(e) => {
              if (commentData?.user_id?.gender === "M") {
                // console.log("insie if")
                e.target.src = commentData?.user_id?.avatar_profile
                  ? "/images/Boys/" +
                    commentData?.user_id?.avatar_profile +
                    ".webp"
                  : "/images/Student_boy_pic.png";
              } else if (commentData?.user_id?.gender === "F") {
                e.target.src = commentData?.user_id?.avatar_profile
                  ? "/images/Girls/" +
                    commentData?.user_id?.avatar_profile +
                    ".webp"
                  : "/images/Student_girl_pic.png";
              } else {
                e.target.src = "/images/default image.png";
              }
            }}
          />
        )}
        <div
          className="d-flex flex-column rounded-3 px-2 py-1 w-100"
          style={{ backgroundColor: "#e5eceb" }}
        >
          <div className="">
            {commentData?.user_id?.user_type === "Teacher" && (
              <img
                className="mr-1 teacher_icon"
                src="/images/teacher_icon.svg"
                alt=""
              />
            )}
            <span className="write_user_name">
              {commentData?.user_id?.name} &nbsp;
            </span>
            {commentData?.user_id?.user_type === "Student" && (
              <span className="class_time ">
                {commentData?.user_id?.standard?.name} -{" "}
                {commentData?.user_id?.section?.name}
              </span>
            )}{" "}
            <span className="class_time">
              {moment(timeHelper(commentData?.created_at)).calendar({
                sameDay: "h:mm a",
                lastDay: "[Yesterday]",
                lastWeek: "DD MMM YYYY ",
                sameElse: "DD MMM YYYY",
              })}
            </span>
            {commentData?.isDeleted ? (
              <span className="ml-2 class_time" style={{ color: "red" }}>
                *Deleted
              </span>
            ) : (
              isUpdatedAfterCreated(
                commentData?.created_at,
                commentData?.updated_at
              ) && (
                <span className="ml-2 class_time" style={{ color: "blue" }}>
                  Edited
                </span>
              )
            )}
          </div>

          {editMode ? (
            <div className="d-flex  flex-row gap-2 w-100">
              <TextField
                multiline
                rows={3}
                value={editedComment}
                onChange={(e) => setEditedComment(e.target.value)}
                fullWidth
                variant="outlined"
                size="small"
                sx={{ backgroundColor: "white" }}
              />
              <div className="d-flex gap-2 justify-end">
                <IconButton
                  size="small"
                  color="success"
                  onClick={handleSaveEdit}
                >
                  <Check fontSize="small" />
                </IconButton>
                <IconButton
                  size="small"
                  color="error"
                  onClick={() => {
                    setEditedComment(commentData.comment);
                    setEditMode(false);
                  }}
                >
                  <Close fontSize="small" />
                </IconButton>
              </div>
            </div>
          ) : (
            <span
              className="post_comment comments-text block"
              style={{ maxWidth: "780px", whiteSpace: "pre-wrap" }}
            >
              {commentData?.comment}
            </span>
          )}
        </div>

        {!commentData?.isDeleted &&
          (isAdminOrTeacherAdmin || commentData?.user_id?.id === user_id) && (
            <div className="position-absolute end-0 top-0 flex space-x-2">
              {commentData?.user_id?.user_type === "Teacher" && (
                <IconButton
                  size="small"
                  color="primary"
                  onClick={() => {
                    setEditMode(true);
                    setEditedComment(commentData.comment);
                  }}
                >
                  <Edit fontSize="small" />
                </IconButton>
              )}

              <IconButton
                size="small"
                color="error"
                onClick={() => setDeletePopup(true)}
              >
                <DeleteOutline fontSize="small" />
              </IconButton>
            </div>
          )}

        {deletePopup && (
          <Dialog open={deletePopup} onClose={() => setDeletePopup(false)}>
            <DialogTitle>Confirm Delete</DialogTitle>
            <DialogContent>
              <DialogContentText>
                Are you sure you want to delete this comment?
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={() => setDeletePopup(false)} color="primary">
                Cancel
              </Button>
              <Button
                onClick={() => {
                  setDeletePopup(false);
                  DeleteComment(); // आपका delete function
                }}
                color="error"
                autoFocus
              >
                Delete
              </Button>
            </DialogActions>
          </Dialog>
        )}
      </div>
    </div>
  ) : (
    <></>
  );
};

export default CommentList;
